/**
 * Module dependencies.
 */

import { DescriptionWrapper } from '../products/products.style';
import { JSX } from 'react';
import { StyledDescription, StyledTitle } from './catalog-introduction.style';
import { useTranslation } from 'next-i18next';

/**
 * Export `CatalogIntroduction` component.
 */

export function CatalogIntroduction(): JSX.Element {
  const [translate] = useTranslation();

  return (
    <>
      <StyledTitle center>
        {translate('catalog.introduction.title')}
      </StyledTitle>

      <DescriptionWrapper>
        <StyledDescription>
          {translate('catalog.introduction.description')}
        </StyledDescription>
      </DescriptionWrapper>
    </>
  );
}
